var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#f7d430;}")),React.createElement("rect",{"className":"cls-1","width":"49.85","height":"5","key":1}),React.createElement("rect",{"className":"cls-1","y":"12.67","width":"49.85","height":"5","key":2}),React.createElement("rect",{"className":"cls-1","y":"25.34","width":"49.85","height":"5","key":3})]);
}

Burger.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 49.85 30.34"};

module.exports = Burger;

Burger.default = Burger;
